import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import type { Requisition } from '@core/requisitions-types';

import type { RequisitionsAbilities } from '../../data/single-requisition/requisitions-data-provider.service';
import { RequisitionsDataProviderService } from '../../data/single-requisition/requisitions-data-provider.service';

@Injectable()
export class TeamMembersFacade {
  protected readonly store = inject(Store);
  protected readonly requisitionsData = inject(RequisitionsDataProviderService);

  private requisition: Requisition;
  private abilities: RequisitionsAbilities;
  private isRequisitionReadOnly: boolean;
  private ngOnDestroy$ = new Subject<void>();

  constructor() {
    const requisitionsData = this.requisitionsData;

    requisitionsData.data$
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(({ requisition, abilities, isRequisitionReadOnly }) => {
        this.requisition = requisition;
        this.abilities = abilities;
        this.isRequisitionReadOnly = isRequisitionReadOnly;
      });
  }

  public get canEditTeamMembers(): boolean {
    return this.abilities.manageRequisitions && !this.isRequisitionReadOnly;
  }

  // TODO - move logic from requisitions-team-members.service here

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
